export function FilledBarIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        width="4"
        height="16"
        rx="1"
        transform="matrix(-1 0 0 1 16 0)"
        fill={props.color || '#1DA44A'}
      />
      <rect
        width="4"
        height="12"
        rx="1"
        transform="matrix(-1 0 0 1 10 4)"
        fill={props.color || '#1DA44A'}
      />
      <rect
        width="4"
        height="8"
        rx="1"
        transform="matrix(-1 0 0 1 4 8)"
        fill={props.color || '#1DA44A'}
      />
    </svg>
  );
}

export default FilledBarIcon;
